import {Trigger as DropdownTrigger} from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

type RunRowHeaderMenuTriggerProps = {
  open: boolean;
  setMenuOpen: (open: boolean) => void;
};

export function RowHeaderMenuTrigger(props: RunRowHeaderMenuTriggerProps) {
  // The WBTable.less stylesheet has some styling that makes the trigger element
  // disappear after you've opened the menu, which seems bad. Changing the
  // stylesheet seems dangerous, so this is a hack to ensure the trigger remains
  // visible and obvious to the user.
  const style = {
    opacity: props.open ? 1 : undefined,
  };

  return (
    <DropdownTrigger onClick={() => props.setMenuOpen(true)}>
      <div className="show-run-menu" style={style}>
        <Icon
          name="overflow-vertical"
          aria-label="Show run menu"
          height={20}
          width={20}
          color="#2e78c7"
        />
      </div>
    </DropdownTrigger>
  );
}
